import script from "./RestaurantPosTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RestaurantPosTable.vue?vue&type=script&setup=true&lang=js"

import "./RestaurantPosTable.vue?vue&type=style&index=0&id=033d56d3&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-033d56d3"]])

export default __exports__